import { render, staticRenderFns } from "./BuyoutEvent.vue?vue&type=template&id=3d556e6f"
import script from "./BuyoutEvent.vue?vue&type=script&lang=js"
export * from "./BuyoutEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports